import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  numberAttribute,
  ViewEncapsulation,
} from '@angular/core';

import { clamp } from '../util/math';
import { BspkIcon } from '../icon/icon.component';
import { ProgressStepperItem } from '../progress-stepper';

@Component({
  selector: 'bspk-progress-stepper-widget',
  imports: [BspkIcon],
  templateUrl: './progress-stepper-widget.component.html',
  styleUrl: './progress-stepper-widget.component.scss',
  host: {
    'data-bspk': 'progress-stepper-widget',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BspkProgressionStepperWidget {
  readonly steps = input.required<ProgressStepperItem[]>();
  readonly currentStep = input(0, { transform: numberAttribute });
  protected readonly Math = Math;
  protected readonly currentStepNumber = computed(() => clamp(this.currentStep(), 0, this.steps().length - 1));
}
